import { render } from "./RegistrosAcelerometricos.vue?vue&type=template&id=1f426c10&scoped=true"
import script from "./RegistrosAcelerometricos.vue?vue&type=script&lang=js"
export * from "./RegistrosAcelerometricos.vue?vue&type=script&lang=js"

import "./RegistrosAcelerometricos.vue?vue&type=style&index=0&id=1f426c10&scoped=true&lang=css"

import exportComponent from "/opt/web_acelerometrica_publica/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f426c10"]])

export default __exports__